<template>
	<Layout :class="'bg-white p-2'">
		<Row class="m-1 float">
			<Col class="p-1" span="5">
			<Input v-model="searchKey.deviceNumber" placeholder="请输入设备编号" />
			</Col>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="searchKey.alarmValue" placeholder="请输入报警值" />
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="searchKey.alarmValueMax" placeholder="请输入最大报警值" />
			</Col>
			<Button class="float-right m-1" type="error" shape="circle" v-show="adm" @click="newDevice"
				icon="ios-add">新增</Button>
		</Row>
		<Row class="m-1">
			<Col class="p-1" span="5">
			<Select v-model="searchKey.deviceType" clearable placeholder="设备型号" class="w-100">
				<Option v-for="item in deviceType" :value="item.deviceTypeNum">{{ item.deviceType }}</Option>
			</Select>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="searchKey.timeInterval" placeholder="请输入上传时间间隔" />
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="searchKey.timeIntervalMax" placeholder="请输入最大上传时间间隔" />
			</Col>
			<Button class="m-1 float-right" type="primary" shape="circle" @click="search" icon="ios-search">查询</Button>
		</Row>
		<Layout :class="'bg-white'">
			<Table border :class="'m-1'" :columns="tableInfo.columnInfo" :data="tableInfo.data">
				<template slot-scope="{ row, index }" slot="deviceType">
					{{turnDeviceNumToDevice(row)}}
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px"
						@click="show(row.id,row.userId)">详情</Button>
				</template>
			</Table>
			<Page :class="'m-2 text-right'" :page-size="tableInfo.pageSize" @on-change="pageSearch"
				:total="tableInfo.total" />
		</Layout>
	</Layout>
</template>
<script>
	export default {
		data() {
			return {
				adm: "",
				searchKey: {
					userId: "",
					deviceNumber: "",
					deviceType: "",
					alarmValue: "",
					timeInterval: "",
					alarmValueMax: "",
					timeIntervalMax: "",
				},
				deviceType: [],
				tableInfo: {
					currentPage: 1,
					total: 0,
					pageSize: 10, //每页显示10条

					columnInfo: [{
							title: "设备编号",
							align: 'center',
							key: "deviceNumber"
						},
						{
							title: "设备型号",
							align: 'center',
							slot: "deviceType"
						},
						{
							title: "报警值",
							align: 'center',
							key: "alarmValue"
						},
						{
							title: "上传时间间隔",
							align: 'center',
							key: "timeInterval"
						},
						{
							title: "操作",
							align: 'center',
							slot: 'action'
						}
					],
					data: []
				},
				state: [{
						value: '',
						label: '全部'
					},
					{
						value: 'true',
						label: '已删除'
					},
					{
						value: 'false',
						label: '未删除'
					}
				]
			}
		},
		methods: {
			init: function() {
				this.$data.tableInfo.currentPage = 0;
				this.search();
			},
			newDevice: function() {
				let userId = this.searchKey.userId;
				this.$router.push({
					name: "device_new",
					params: {
						userId
					}
				});
			},
			show: function(id, userId) {
				this.$router.push({
					name: "device_detail",
					params: {
						id,
						userId
					}
				});
			},
			turnDeviceNumToDevice: function(row) {
				var deviceType = "...";
				if (row.deviceType != null) {
					this.$data.deviceType.forEach(item => {
						if (item.deviceTypeNum == row.deviceType) {
							deviceType = item.deviceType;
						}
					})
				}
				return deviceType
			},
			search: function() {
				this.http.get({
					url: "/device/page/g",
					param: this.searchKey
				}).then(data => {
					this.$data.tableInfo.currentPage = data.DATA.current;
					this.$data.tableInfo.total = data.DATA.total;
					this.$data.tableInfo.pageSize = data.DATA.size;
					this.$data.tableInfo.data = data.DATA.records;
				});
			},
			pageSearch: function(changedPage) {
				this.$data.tableInfo.currentPage = changedPage;
				this.searchKey.current = changedPage;
				this.search();
			},
			searchDeviceType: function() {
				this.http.get({
					url: "/device-type/list",
				}).then(data => {
					this.$data.deviceType = data;
				});
			},
		},
		created: function() {
			this.searchDeviceType();
		},
		mounted: function() {
			this.adm = JSON.parse(sessionStorage.getItem("CURRENT_USER")).adm;
			if (JSON.parse(sessionStorage.getItem("CURRENT_USER")).adm == true) {
				this.searchKey.userId = this.$route.params.userId;
			} else {
				this.searchKey.userId = JSON.parse(sessionStorage.getItem("CURRENT_USER")).userId;
			}
			this.init();

		}


	}
</script>

<style>

</style>
